import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import settings from 'settings';
import _ from 'lodash';
import { Form } from 'antd';
import ExtendedSelect from 'components/extendedSelect/extended-select';
import { FormWrapper } from 'components/Page';
import { convertToSelect, getKey, getLabel } from 'library/helpers';
import { list } from 'actions';
import REDUCER_KEY from 'reducers/reducer.keys';

const FormItem = Form.Item;

const mapStateToProps = state => ({
  legs: state.api.availabilityLegs.data.results,
  inFlight: state.api.availabilityLegs.inFlight
});

const mapDispatchToProps = dispatch => ({
  loadLegs(searchText = '') {
    const page = 0;
    const pageSize = settings.APP_CONFIG.dropListSize;
    const sorted = [{
      id: 'name',
      desc: false
    }];
    const filters = [];

    if (!_.isEmpty(searchText)) {
      filters.push({
        id: 'name__icontains',
        value: searchText
      });
    }
    filters.push({
      id: 'active',
      value: true
    });
    return dispatch(list(REDUCER_KEY.availabilityLegs.key, {
      page,
      pageSize,
      filters,
      sorted
    }));
  }
});

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const { leg } = dataSource;

  return {
    leg: Form.createFormField({ value: convertToSelect(leg) })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, dataSource, inFlight, inputFormItemLayout, form, legs, loadLegs
}) => {
  const { getFieldDecorator } = form;
  const { leg } = dataSource;
  const readonly = !canAdmin;
  return (
    <Form>
      <FormItem {...inputFormItemLayout} label="Leg">
        {
          getFieldDecorator('leg', {
            initialValue: leg,
            rules: [
              {
                required: true,
                message: 'Please select a Leg.'
              }
            ]
          })(
            <ExtendedSelect
              fetching={inFlight}
              placeholder="Select a Leg"
              dataSource={legs}
              optionKey={getKey}
              optionLabel={getLabel}
              disabled={readonly}
              onSearch={loadLegs}
              onFocus={loadLegs}
            />
          )
        }
      </FormItem>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  checkboxFormItemLayout: PropTypes.object,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  inFlight: PropTypes.bool,
  inputFormItemLayout: PropTypes.object,
  legs: PropTypes.array,
  loadLegs: PropTypes.func,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func
};

FormInput.defaultProps = {
  canAdmin: false,
  checkboxFormItemLayout: {},
  dataSource: {},
  form: {},
  inFlight: false,
  inputFormItemLayout: {},
  legs: [],
  loadLegs() {
  },
  onFieldsChange() {
  },
  onValuesChange() {
  }
};

const ConnectedFormInput = connect(
  mapStateToProps,
  mapDispatchToProps
)(FormInput);

const CycleLegFormInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(ConnectedFormInput));

export default CycleLegFormInput;
